// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"toolbar--3lsFxF_zoU","light":"light--kimzCuBpr6","dark":"dark--aiJNcA3th-","controls":"controls--3ZTGDzASkc","icons":"icons--3YOBCuspi8","icon":"icon--2nea3d69rQ"};